import { render } from "./pasdeh.vue?vue&type=template&id=388961d0&scoped=true"
import script from "./pasdeh.vue?vue&type=script&lang=js"
export * from "./pasdeh.vue?vue&type=script&lang=js"

import "./css/pasdeh.scss?vue&type=style&index=0&id=388961d0&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/div2-univRenewal-trunk-production/web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-388961d0"]])

export default __exports__